import React from 'react';
import { NudosGenericModal } from 'components/NudosComponents';
import OrdersCancelledModalContent from './OrdersCancelledModalContent/OrdersCancelledModalContent';

const OrdersCancelledModal = ({ isOpen, onClose }: IOrdersCancelledModalProps) => {
  if (!isOpen) return null;

  return (
    <NudosGenericModal
      modalContent={<OrdersCancelledModalContent handleClose={onClose} />}
      closeModalCallback={onClose}
    />
  );
};

interface IOrdersCancelledModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default OrdersCancelledModal;
